import * as React from 'react';
const IconDelete = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    style={{ width: '22px', height: '22px' }}
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <path d="M7 11H15" stroke="#020000" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
    <circle cx={11} cy={11} r={9.5} stroke="#020000" strokeWidth={3} />
  </svg>
);
export default IconDelete;
